export default __webpack_public_path__ + "static/media/M1A_5.a30d960e.png";